import { createContext, useContext, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import LeadForm from "./LeadForm";
import { LOGO } from "../data/site";

const QuoteCtx = createContext(null);
export const useQuote = () => useContext(QuoteCtx);

export function QuoteProvider({ children }) {
  const [open, setOpen] = useState(false);
  return (
    <QuoteCtx.Provider value={{ open, openQuote: () => setOpen(true), closeQuote: () => setOpen(false) }}>
      {children}
      <AnimatePresence>
        {open && (
          <motion.div
            className="fixed inset-0 z-[90] flex items-center justify-center p-4"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          >
            <div className="absolute inset-0 bg-[#0D0D0D]/80 backdrop-blur-md" onClick={() => setOpen(false)} />
            <motion.div
              data-testid="quote-modal"
              className="relative w-full max-w-lg glass rounded-md p-6 sm:p-8 max-h-[92vh] overflow-y-auto"
              initial={{ scale: 0.94, y: 20, opacity: 0 }}
              animate={{ scale: 1, y: 0, opacity: 1 }}
              exit={{ scale: 0.94, y: 20, opacity: 0 }}
              transition={{ ease: [0.16, 1, 0.3, 1], duration: 0.4 }}
            >
              <button data-testid="quote-modal-close" onClick={() => setOpen(false)}
                className="absolute top-4 right-4 text-white/60 hover:text-[#D4AF37] transition-colors">
                <X size={22} strokeWidth={1.5} />
              </button>
              <img src={LOGO} alt="Sterling Roofworks" className="w-40 mb-4" />
              <h3 className="font-head text-2xl uppercase tracking-tight mb-1">Get Your Free Quote</h3>
              <p className="text-sm text-[#C8C8C8] mb-5">No obligation. Free survey. Fixed pricing.</p>
              <LeadForm source="quote-modal" compact tid="modal-lead" onSuccess={() => setOpen(false)} />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </QuoteCtx.Provider>
  );
}
